<template>
    <v-img contain height="22vh"
           class="ma-auto"
           src="~@/assets/custom/images/header-logo.png"/>
</template>

<script>
export default {
  name: 'LogoNoText'
}
</script>
